import { SidePanel, Text, Label, Divider, Link, ButtonGroup, Button, StatusIndicator } from '@nike/eds';
import type { Exception } from '../../shared/Types';
import './exception-detail.css';
import { formatExceptionDate } from '../exceptions-table/ExceptionTableColumns';
import { mapPriorityToStatus } from '../../shared/Utils';

import { AuditComments } from './AuditComments';

interface ExceptionDetailProps {
  isOpen: boolean;
  onClose: () => void;
  viewingException: Exception | null | undefined;
}

const ExceptionDetailContent = ({ exception }: { exception: Exception }) => {

return (
  <div className='exception-detail-content eds-grid  eds-grid eds-spacing--mb-48' >
    <div className="eds-grid eds-grid--m-cols-2">
      <div>
        <Label font={'body-3'} >Exception ID:</Label>
        <Text font={'title-4'}>{exception.id}</Text>
      </div>
      <div className="eds-flex eds-flex--justify-content-flex-end">
        <div className="eds-flex eds-flex--align-items-center" style={{ height: '100%' }}>
          <StatusIndicator label={exception.priority} size="x-large" status={mapPriorityToStatus(exception.priority)} />
        </div>
      </div>
      <div className="eds-grid--col--full">
        <Link font={'body-1'}>Shipment Details</Link>
      </div>
    </div>
    <Divider />
    <div className="eds-grid eds-grid--m-cols-2">
      <div>
        <Label font={'body-3'}>Exception Type</Label>
        <Text font={'body-1'}>{exception.description}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Status</Label>
        <Text font={'body-1'}>{exception.status}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Assignee</Label>
        <Text font={'body-1'}>{exception.assignee?.name} ({exception.assignee?.email || 'N/A'})</Text>
      </div>
      <div>
        <Label font={'body-3'}>Resolution Type</Label>
        <Text font={'body-1'}>{exception.resolutionType}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Creation Date</Label>
        <Text font={'body-1'}>{formatExceptionDate(exception.creationDate)}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Target Resolution Date</Label>
        <Text font={'body-1'}>{formatExceptionDate(exception.targetResolutionDate)}</Text>
      </div>

      <div className="eds-grid--col--full">
        <Label font={'body-3'}>Guidance</Label>
        <Text font={'body-1'}>TBD</Text>
      </div>

    </div>
    <Divider />   
    <div className="eds-grid eds-grid--m-cols-2">
      <div>
        <Label font={'body-3'}>Consignment ID</Label>
        <Text font={'body-1'}>{exception.consignment.id}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Bill of Lading #</Label>
        <Text font={'body-1'}>{exception.consignment.billOfLadingNbr}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Mode of Transport</Label>
        <Text font={'body-1'}>{exception.consignment.modeOfTransport}</Text>
      </div>
      <div>
        <Label font={'body-3'}>Carrier</Label>
        <Text font={'body-1'}>{exception.consignment.carrier}</Text>
      </div>
      <div className="eds-grid--col--full">
        <Label font={'body-3'}>Origin Country</Label>
        <Text font={'body-1'}>{exception.consignment.originCountry}</Text>
      </div>
      <div className="eds-grid--col--full">
        <Label font={'body-3'}>Discharge Country</Label>
        <Text font={'body-1'}>{exception.consignment.dischargeCountry}</Text>
      </div>
    </div>
    <Divider />

    <Label font={'title-3'}>Actions</Label>
    <ButtonGroup>
      <Button
        variant="primary"
        onClick={() => {
          // Handle edit action
          console.log("Retry:", exception.id);
        }}
      >
        Retry
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          // Handle resolve action
          console.log("Resolve:", exception.id);
        }}
      >
        Resolve
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          // Handle close action
          console.log("Assign to Me:", exception.id);
        }}
      >
        Assign to Me
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          // Handle close action
          console.log("Reassign to:", exception.id);
        }}
      >
        Reassign
      </Button>
    </ButtonGroup>

    <Divider />
    
    <AuditComments exception={exception} />


  </div>
)};

export const ExceptionDetail = ({ isOpen, onClose, viewingException }: ExceptionDetailProps) => {
  if (!viewingException) return null;

  return (
    <SidePanel
      displayCheckOverride={true} // Override to always show the side panel
      hideScrim={true} // Hide the scrim to allow interaction with the main content
      onDismiss={onClose}
      isOpen={isOpen}
      headerSlot={<Text>Exception Details</Text>}
    >
      <ExceptionDetailContent exception={viewingException} />
    </SidePanel>
  );
}